// Test IDs for REP - Proyecto Diamante features
export const NAV = {
  home: 'nav-home',
  formulario: 'nav-formulario',
  login: 'nav-login',
  logout: 'nav-logout',
  dashboard: 'nav-dashboard',
};

export const LANDING = {
  heroCtaForm: 'hero-cta-form',
  heroCtaWhatsapp: 'hero-cta-whatsapp',
  footerCtaForm: 'footer-cta-formulario',
  locationCard: (i) => `location-card-${i}`,
  faqItem: (i) => `faq-item-${i}`,
};

export const FORM = {
  container: 'qualification-form',
  step: (i) => `form-step-${i}`,
  next: 'form-next-button',
  prev: 'form-prev-button',
  submit: 'form-submit-button',
  field: (k) => `form-field-${k}`,
  success: 'form-success-panel',
};

export const CRM = {
  loginBtn: 'crm-login-button',
  logoutBtn: 'crm-logout-button',
  pipelineColumn: (s) => `pipeline-col-${s}`,
  leadCard: (id) => `lead-card-${id}`,
  leadDetail: 'lead-detail-panel',
  addNoteBtn: 'lead-add-note-button',
  noteInput: 'lead-note-input',
  stageSelect: 'lead-stage-select',
  summaryTotal: 'summary-total',
  summaryCapital: 'summary-capital',
  summaryConversion: 'summary-conversion',
  tabPipeline: 'tab-pipeline',
  tabLocations: 'tab-locations',
  tabUsers: 'tab-users',
  tabAudit: 'tab-audit',
};
